module.exports = __webpack_public_path__ + "static/media/tablet.b7bd3a0a.svg";